/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Final_TitleInputs */

const en_mk_final_title = /** @type {(inputs: Mk_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start working alongside your team and AI agents today.`)
};

const id_mk_final_title = /** @type {(inputs: Mk_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai kerja bareng tim dan agen AI-mu hari ini.`)
};

/**
* | output |
* | --- |
* | "Start working alongside your team and AI agents today." |
*
* @param {Mk_Final_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_final_title = /** @type {((inputs?: Mk_Final_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Final_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_final_title(inputs)
	return en_mk_final_title(inputs)
});